import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

const selectListHeight = 330;

const style = theme => ({
    wrapper: {
        flex: '50%',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '50%',
    },
    input: {
        flex: 1,
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid',
        padding: '6px 3px',
    },
    select: {
        flex: 1,
        width: '100%',
        border: '1px solid',
        borderColor: theme.palette.divider,
        height: selectListHeight,
        maxHeight: selectListHeight,
        overflow: 'auto',
    },
    error: { borderColor: theme.palette.error.main },
    textField: {
        margin: 0,
        marginBottom: theme.spacing(),
        marginTop: theme.spacing(),
    },
    headerName: {
        fontWeight: 500,
    },

    listItemText: {
        fontSize: '14px',
    },

    listItemGutters: {
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 0,
        paddingBottom: 0,
    },
});

class ListBox extends React.Component {
    state = {
        filterKeyword: '',
    };

    onFilterKeywordChange = event => {
        const filterKeyword = event.target.value;
        this.setState({ filterKeyword });
    };

    handleTransferSingle = ({ value, selectable = true }) => event => {
        if (selectable) {
            this.props.onTransfer([value]);
        }
    };

    handleTransfer = () => {
        const toTransfer = this.props.options
            .filter(({ selectable = true }) => selectable)
            .map(({ value }) => value);

        this.props.onTransfer(toTransfer);
    };

    render() {
        const { filterKeyword } = this.state;
        const {
            disabled,
            options,
            buttonContent,
            classes,
            headerName,
            className,
            error,
        } = this.props;

        const filteredOptions = options.filter(
            option =>
                option.label
                    .toLowerCase()
                    .indexOf(filterKeyword.toLowerCase()) !== -1
        );

        return (
            <div className={classNames(classes.wrapper, className)}>
                <Typography variant="body2" className={classes.headerName}>
                    {headerName}
                </Typography>
                <TextField
                    label="Filter"
                    type="search"
                    disabled={disabled}
                    className={classes.textField}
                    variant="outlined"
                    margin="dense"
                    value={filterKeyword}
                    onChange={this.onFilterKeywordChange}
                />

                <Button
                    variant="outlined"
                    size="small"
                    className={classes.button}
                    onClick={this.handleTransfer}
                    disabled={options.length === 0 || disabled}
                >
                    {buttonContent}
                </Button>

                <List
                    className={classNames({
                        [classes.select]: true,
                        [classes.error]: error,
                    })}
                >
                    {filteredOptions.map((option, index) => (
                        <ListItem
                            disabled={disabled}
                            key={option.value}
                            role={undefined}
                            dense
                            button
                            classes={{ gutters: classes.listItemGutters }}
                            onClick={this.handleTransferSingle(option)}
                        >
                            <ListItemText
                                primary={option.label}
                                className={classes.listItemText}
                            />
                        </ListItem>
                    ))}
                </List>
            </div>
        );
    }
}

export default withStyles(style)(ListBox);
